export class Authetication {
  userName: string;
  userId: any;
  z: string;
  vendor: any;
  token: string;
  email: string;
  display_name: string;
  designation: string;
  profile_pic: string;
  is_latral: any;
  is_password_expired: boolean;
  password_reset_token: any;
  constructor() {
    this.userName = "";
    this.userId = "";
    this.z = "";
    this.token = "";
    this.email = "";
    this.display_name = "";
    this.designation = "";
    this.profile_pic = "";
  }
}
